import { inject, injectable } from "inversify";
import { FileParameter, ICPLAIInvoicesClient, ProcessedInvoiceModel } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { rethrowAsError } from "./api/problemDetailsToError";

export interface IAIInvoicesService {
  processInvoice(file: File): Promise<ProcessedInvoiceModel>;
}

@injectable()
export class AIInvoicesService implements IAIInvoicesService {
  @inject(SERVICE_TYPES.CPLAIInvoicesClient) cplAIInvoicesClient!: ICPLAIInvoicesClient;

  async processInvoice(file: File): Promise<ProcessedInvoiceModel> {
    const fileParam: FileParameter = { data: file, fileName: file.name };
    return this.cplAIInvoicesClient.processInvoice({ file: fileParam }).catch(rethrowAsError);
  }
}
